(function () {
hubspot.define('hubspot.SafeStorage', [], function() {
  var storage;
  storage = {};
  return {
    getItem: function(key) {
      if (this._isLocalStorageAvailable()) {
        return localStorage.getItem(key);
      } else {
        return storage[key];
      }
    },
    setItem: function(key, value) {
      if (this._isLocalStorageAvailable()) {
        return localStorage.setItem(key, value);
      } else {
        return storage[key] = value;
      }
    },
    removeItem: function(key) {
      if (this._isLocalStorageAvailable()) {
        return localStorage.removeItem(key);
      } else {
        return delete storage[key];
      }
    },
    clear: function() {
      if (this._isLocalStorageAvailable()) {
        return localStorage.clear();
      } else {
        return storage = {};
      }
    },
    _isLocalStorageAvailable: function() {
      var e, error, testValue;
      if (this.localStorageAvailable == null) {
        try {
          testValue = 'SafeStorageTestValue';
          localStorage.setItem(testValue, testValue);
          this.localStorageAvailable = testValue === localStorage.getItem(testValue);
          localStorage.removeItem(testValue);
        } catch (error) {
          e = error;
          console.log('localStorage is not available:', e);
          this.localStorageAvailable = false;
        }
      }
      return this.localStorageAvailable;
    }
  };
});
}());

